var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.35054C1.00684 2.494 2.57895 0.993889 4.51161 1.00002C6.44473 1.00659 8.00636 2.51677 7.99998 4.37375V4.41141C7.97582 5.6186 7.27432 6.73427 6.4142 7.60606C5.92237 8.09691 5.37311 8.53127 4.77736 8.90082C4.61828 9.03306 4.38171 9.03306 4.22263 8.90082C3.33424 8.34517 2.55479 7.64416 1.91984 6.8293C1.35326 6.11864 1.03191 5.25648 1 4.36193V4.35054Z",
    stroke: "#FFFFFE",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49964 6.03494C5.11914 6.03494 5.62134 5.55251 5.62134 4.95741C5.62134 4.36231 5.11914 3.87988 4.49964 3.87988C3.88014 3.87988 3.37793 4.36231 3.37793 4.95741C3.37793 5.55251 3.88014 6.03494 4.49964 6.03494Z",
    stroke: "#FFFFFE",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d444c803bdfbdc5b60bba48eb767ef80.svg";
export { ForwardRef as ReactComponent };